module.exports = __webpack_public_path__ + "img/course-bigcover01.aff7c3d7.png";